import { createApi } from '@reduxjs/toolkit/query/react'

import { baseQueryWithReauth } from '../../../../redux-store/services/services.utils'

export const metadataApi = createApi({
  reducerPath: 'metadataApi',
  baseQuery: baseQueryWithReauth,
  endpoints: (builder) => ({
    getValidationRules: builder.query<
      any,
      { practiceId: string; isStrict: boolean }
    >({
      query: (args: any) =>
        `metadata/validationRules/${args.practiceId}?strict=${
          args.isStrict ? 1 : 0
        }`,
    }),
  }),
})
